var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.71396C15 11.081 11.866 13 8 13C4.134 13 1 11.081 1 8.71396C1 6.34696 4.134 4.42896 8 4.42896C11.866 4.42896 15 6.34696 15 8.71396Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74969 8.71397C9.76431 9.42487 9.34734 10.074 8.6947 10.3562C8.04207 10.6384 7.28353 10.4977 6.77554 10.0002C6.26756 9.50266 6.11112 8.74722 6.37974 8.08886C6.64836 7.4305 7.28863 7.00012 7.99968 6.99997C8.45905 6.99517 8.9015 7.17307 9.22969 7.49451C9.55789 7.81595 9.74494 8.25461 9.74969 8.71397V8.71397Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    d: "M7.25 4.429C7.25 4.84321 7.58579 5.179 8 5.179C8.41421 5.179 8.75 4.84321 8.75 4.429H7.25ZM8.75 1C8.75 0.585786 8.41421 0.25 8 0.25C7.58579 0.25 7.25 0.585786 7.25 1H8.75ZM14.7931 3.05471C14.9813 2.68571 14.8347 2.23403 14.4657 2.04586C14.0967 1.85769 13.645 2.00428 13.4569 2.37329L14.7931 3.05471ZM12.0199 5.19129C11.8317 5.5603 11.9783 6.01197 12.3473 6.20014C12.7163 6.38831 13.168 6.24172 13.3561 5.87271L12.0199 5.19129ZM2.54314 2.37329C2.35497 2.00428 1.90329 1.85769 1.53429 2.04586C1.16528 2.23403 1.01869 2.68571 1.20686 3.05471L2.54314 2.37329ZM2.64386 5.87271C2.83203 6.24172 3.28371 6.38831 3.65271 6.20014C4.02172 6.01197 4.16831 5.5603 3.98014 5.19129L2.64386 5.87271ZM8.75 4.429V1H7.25V4.429H8.75ZM13.4569 2.37329L12.0199 5.19129L13.3561 5.87271L14.7931 3.05471L13.4569 2.37329ZM1.20686 3.05471L2.64386 5.87271L3.98014 5.19129L2.54314 2.37329L1.20686 3.05471Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.059a7983c5b3aa0fc2f674169c02a21a.svg";
export { ForwardRef as ReactComponent };